// extracted by mini-css-extract-plugin
export default {"wmCard":"WmCard_wmCard__kK0FA"};